import './author-and-date.scss';
import './author-and-date.html.twig';

export default function () {
    const authorBlock = document.querySelector('.author-and-date__author-info');
  
    if (!authorBlock) {
      return;
    }
  
    authorBlock.addEventListener('click', () => {
      const link = authorBlock.querySelector('.author-and-date__author-name');
      if (link) {
        link.click();
      }
    });
  }
